import { useEffect } from 'react'
import { importAndSwitchPhoneNumbers } from '../../../../utilities/phoneNumbers'
import { FC } from 'react'

/**
 * Google Ads contain query parameters with phone numbers for call tracking. Update the site with the ad phone number.
 * @constructor
 */
interface PhoneNumberReplacer {
    isCorporate: boolean
}

export const PhoneNumberReplacer: FC<PhoneNumberReplacer> = ({
    isCorporate,
}) => {
    useEffect(() => {
        importAndSwitchPhoneNumbers()

        const phoneNumbers = document.querySelectorAll(
            '[data-phone]'
        ) as NodeList

        if (
            window.sessionStorage.formatted_phone_number &&
            window.sessionStorage.unformatted_phone_number
        ) {
            phoneNumbers.length > 0 &&
                phoneNumbers.forEach((phoneNumber, i) => {
                    phoneNumber.textContent =
                        window.sessionStorage.formatted_phone_number

                    const phoneNumberHref = phoneNumber as HTMLAnchorElement

                    phoneNumberHref.href = `tel:+1${window.sessionStorage.unformatted_phone_number}`
                })
        }
    }, [isCorporate])

    return <></>
}

export default PhoneNumberReplacer
